module.exports = __webpack_public_path__ + "static/2-9af5f0a64755d1361fa5718c4254d521.jpg";